module.exports = __webpack_public_path__ + "img/pay-value11.27a61145.png";